import { returnsCenterIdFormat } from "@redotech/redo-ids/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const CreateReturnsCenterInputSchema_ = z.object({
  name: z.string().min(1),
  street1: z.string().nullable(),
  street2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().nullable(),
  country: z.string().nullable(),
});

export const CreateReturnsCenterInputSchema: z.ZodType<CreateReturnsCenterInput> =
  CreateReturnsCenterInputSchema_;
export interface CreateReturnsCenterInput
  extends z.infer<typeof CreateReturnsCenterInputSchema_> {}

export const createReturnsCenter = unaryRpc({
  name: "createReturnsCenter" as const,
  input: CreateReturnsCenterInputSchema,
  output: z.object({ id: returnsCenterIdFormat.schema }),
});
